var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-empty',[_c('div',{staticClass:"page-error"},[_c('h1',[_vm._v("400")]),_c('p',[_vm._v("Bad request")]),_c('router-link',{staticClass:"sp-button-filled",attrs:{"to":{ name: 'home' }}},[_vm._v("Tillbaka")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }